import Slider from "react-slick";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";

import { useEffect } from "react";
import { useSelector } from "react-redux";
import { retrieveRAPSHighlights } from "../../redux/slice/raps-highlights-slice";
import { RootState, useAppDispatch } from "../../redux/store";
import bgImg from "../../assets/images/rpas-Highlights-slider/BG-RAPS-Highlights.jpg"
 

var settings = {
  dots: true,
  infinite: true,
  speed: 1000,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  autoplay: true,
  autoplaySpeed: 5000,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
};



const RapsHighlights = () => {
  const path = '/Home/Current-Promotions'
  const { rapsHighlights  } = useSelector(
    (state: RootState) => state.rapsHighlights
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(retrieveRAPSHighlights(path));
  }, [dispatch]);

  return (
    <div className=" bgHL sec-pad text-white" style={{backgroundImage: `url(${bgImg})`}}>
      <div className="container">
        <div className="col-md-12 text-center">
          <h2 >RAPS Highlights</h2>
          <p>&nbsp;</p>
        </div>
        <div className="col-md-12">
          <div id="marketing_slider" className="cursor-grab">
          <Slider {...settings}>
              {rapsHighlights.map((item, index) => {
                return (
                  <div className="" key={index}>
                    <div className="center">
                      <Link to={item.linkURL} target={item.imageTarget}>
                        <img
                          alt="RF Quarterly, <br /> Artificial Intelligence"
                          src={item.image}
                        />
                      </Link>
                    </div>
                    <div className="text-center">
                      <br />
                      <Link to={item.linkURL} className="btn btn-default" role="button" target={item.linkTarget}>
                        {item.linkText}
                      </Link>
                      <h4>{item.title}</h4>
                      <h6>{item.subTitle}</h6>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RapsHighlights;
